module.exports = __webpack_public_path__ + "img/auth_medical_care_movn.adb60126.svg";